import { financeAPI } from "../../axios";

export const actions = {
    AddSubscriber(context, data){
        return financeAPI.post(`Subscriber/Add`, data);
    },
    UpdateSubscriber(context, data){
        return financeAPI.put(`Subscriber/${data.id}`, data);
    },
    RemoveSubscriber(context, data){
        return financeAPI.delete(`Subscriber/${data}`);
    },
    GetSubscriberByDUService(context, data){
        return financeAPI.get(`Subscriber/DeliveryUnitService/${data}`);
    },
    GetSingleSubscriber(context, data){
        return financeAPI.get(`Subscriber/${data}`);
    },
    GetAccountNumber(context, data){
        return financeAPI.get(`Subscriber/GenerateAccountNumber`);
    }
}